import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { GetPunchoutUserIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import { PunchoutUserIdentityState } from "@TKCCP/Store/Data/PunchoutUserIdentity/PunchoutUserIdentityState";
import { PunchoutUserIdentityCollectionModel } from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

const initialState: PunchoutUserIdentityState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/PunchoutUserIdentity/BeginLoadIdentities": (
        draft: Draft<PunchoutUserIdentityState>,
        action: { parameter: GetPunchoutUserIdentityApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/PunchoutUserIdentity/CompleteLoadIdentities": (
        draft: Draft<PunchoutUserIdentityState>,
        action: { parameter: GetPunchoutUserIdentityApiParameter; collection: PunchoutUserIdentityCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.punchoutUserIdentityList!,
            // order => storeIdByOrderNumber(draft, order),
        );
    },
    "Data/PunchoutUserIdentity/Reset": () => {
        return initialState;
    },
};

const punchoutUserreducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).dataPunchoutUserIdentity = punchoutUserreducer;
